<template>
  <div
    class="cart-summary critical-component-clear"
    :class="{ 'cart-summary__small': small }"
  >
    <template v-if="!small">
      <div class="cart-summary__subtotal">
        <p
          class="text-body-2xs-regular"
          v-text="$string('cart.summary.subtotal_label')"
        />

        <p
          class="text-body-2xs-regular"
          v-text="$formatMoney(cart.items_subtotal_price, cnvs?.store.moneyFormat, true)"
        />
      </div>

      <div class="cart-summary__tax">
        <p
          class="text-body-2xs-regular"
          v-text="$string('cart.summary.tax_label')"
        />

        <p
          class="text-body-2xs-regular"
          v-text="$string('cart.summary.calculated_at_checkout')"
        />
      </div>

      <div class="cart-summary__shipping">
        <p
          class="text-body-2xs-regular"
          v-text="$string('cart.summary.shipping_label')"
        />

        <p
          class="text-body-2xs-regular"
          v-text="$string('cart.summary.calculated_at_checkout')"
        />
      </div>
    </template>

    <divider-line v-if="!small" />

    <div class="cart-summary__total">
      <p
        class="text-body-xs-regular"
        :class="{ 'text-other-button-s': !small }"
        v-text="$string('cart.summary.total_label')"
      />

      <p
        class="text-body-xs-regular"
        :class="{ 'text-other-button-s': !small }"
        v-text="$formatMoney(cart.total_price, cnvs?.store.moneyFormat, true)"
      />
    </div>

    <div
      v-if="small"
      class="cart-summary__message-box"
    >
      <p
        class="text-body-2xs-regular"
        v-text="$string('cart.summary.taxes_calculated')"
      />
    </div>

    <btn
      id="checkout"
      class="cart-summary__submit"
      :label="$string('cart.checkout')"
      name="checkout"
      type="submit"
    />

    <btn
      v-if="small &&
        ((isMobile && $variable('settings.cart.showViewCartButtonMobile')) ||
          (!isMobile && $variable('settings.cart.showViewCartButton')))"
      class="cart-summary__view-cart"
      :label="$string('cart.summary.view_cart')"
      :url="cnvs?.routes.cart.url"
      name="view_cart"
      type="button"
      modifiers="outline center block"
    />

    <div
      v-if="!small && $variable('settings.cart.cartSummaryContent')"
      class="cart-summary__footer rte"
      v-html="$localizeRichtext($variable('settings.cart.cartSummaryContent'))"
    />
  </div>
</template>

<script>

/**
 * Vue: Cart summary (cart-summary)
 * -----------------------------------------------------------------------------
 * Summary of cart metrics with checkout CTA.
 *
 * @param {Boolean} [small] - Use mobile layout at all breakpoints.
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'
import DividerLine from '~async/utils/divider-line/divider-line'

export default {
  name: 'CartSummary',

  components: {
    Btn,
    DividerLine,
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cnvs: window.cnvs,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute total discounts.
     * - Includes both compare at price savings and script discounts.
     * @returns {Number}
     */
    totalDiscounts() {
      let savings = 0
      let discounts = 0

      this.cart.items.forEach((lineItem) => {
        if (lineItem.compare_at_line_price) {
          const difference = lineItem.compare_at_line_price - lineItem.final_line_price

          if (difference <= 0) {
            return
          }

          savings += difference
        }

        discounts += lineItem.line_level_total_discount
      })

      return savings + discounts
    },
  },
}
</script>

<style lang="scss">
@import './cart-summary';
</style>
